import { get } from 'lodash-es';

export const getEditOrderOrder = (state) => get(state, 'order');
export const getEditOrderLoading = (state) => get(state, 'loading');
export const getEditOrderHasMadeChanges = (state) => get(state, 'hasMadeChanges', false);
